// extracted by mini-css-extract-plugin
module.exports = {"medical__container":"UploadMedicalDocument_medical__container__Po_Ql","medical__container_body":"UploadMedicalDocument_medical__container_body__SBBiX"};